export default "__VITE_ASSET__BYMWvHLz__"